"use strict";

exports.__esModule = true;
exports.useRequestPromiseLoader = useRequestPromiseLoader;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ACTIONS = {
  LOADING: "loading",
  DATA: "data",
  ERROR: "error"
};
var initialState = {
  loading: true,
  data: [],
  error: undefined
};
function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.LOADING:
      {
        if (typeof action.payload === "boolean") {
          return Object.assign({}, state, {
            loading: action.payload
          });
        }
        return state;
      }
    case ACTIONS.ERROR:
      {
        return Object.assign({}, state, {
          error: action.payload
        });
      }
    case ACTIONS.DATA:
      {
        if (Array.isArray(action.payload)) {
          return Object.assign({}, state, {
            data: action.payload
          });
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
}

/**
 *
 * @returns {React.ReducerState<reducer>}
 * data is an array of results from the supplied array of promises
 */

function useRequestPromiseLoader(props) {
  var _React$useReducer = _react["default"].useReducer(reducer, initialState),
    state = _React$useReducer[0],
    dispatcher = _React$useReducer[1];
  var requests = props.requests;
  function reset(loading, mounted, error) {
    if (mounted) {
      dispatcher({
        type: ACTIONS.LOADING,
        payload: loading
      });
      dispatcher({
        type: ACTIONS.DATA,
        payload: []
      });
      dispatcher({
        type: ACTIONS.ERROR,
        payload: error
      });
    }
  }
  (0, _react.useEffect)(function () {
    var isMounted = true;
    var abortController = new window.AbortController();
    var signal = abortController.signal;
    if (isMounted && requests && requests.length) {
      reset(true, isMounted);
      var promiseList = requests.map(function (request) {
        return typeof request === "function" ? request(signal) : request;
      });
      Promise.all(promiseList).then(function (data) {
        if (isMounted) {
          dispatcher({
            type: ACTIONS.DATA,
            payload: data
          });
          dispatcher({
            type: ACTIONS.LOADING,
            payload: false
          });
        }
      })["catch"](function (error) {
        if (isMounted) {
          reset(false, isMounted, error);
        }
        console.error("Error fetching metrics");
      });
    }
    return function () {
      isMounted = false;
      if (signal && abortController.abort) {
        abortController.abort();
      }
    };
  }, [requests]);
  return state;
}